/**
 * Constants for Virtual Bookshelf feature
 */

/**
 * Default system shelves
 */
export const DEFAULT_SHELVES = [
  {
    id: 'shelf_all',
    name: 'All Books',
    type: 'system',
    bookCount: 0,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'shelf_tbr',
    name: 'TBR',
    type: 'system',
    emoji: '📚',
    description: 'Books to read',
    bookCount: 0,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'shelf_reading',
    name: 'Currently Reading',
    type: 'system',
    emoji: '👁️',
    description: 'Books in progress',
    bookCount: 0,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'shelf_finished',
    name: 'Finished',
    type: 'system',
    emoji: '✓',
    description: 'Books completed',
    bookCount: 0,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'shelf_favorites',
    name: 'Favorites',
    type: 'system',
    emoji: '⭐',
    description: 'Your favorite reads',
    bookCount: 0,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
];

/**
 * Genres for filtering
 */
export const GENRES = [
  'Fiction',
  'Fantasy',
  'Science Fiction',
  'Romance',
  'Mystery',
  'Thriller',
  'Horror',
  'Adventure',
  'Historical Fiction',
  'Literary Fiction',
  'Contemporary',
  'Classics',
  'Young Adult',
  'New Adult',
  'Paranormal',
  'Comedy',
  'Comics',
  'Graphic Novel',
  'Poetry',
  'Non-Fiction',
  'Biography',
  'Memoir',
  'Self-Help',
  'Business',
  'History',
  'Science',
];

/**
 * Book statuses
 */
export const BOOK_STATUSES = [
  { value: 'tbr', label: 'To Be Read', icon: '📚' },
  { value: 'reading', label: 'Currently Reading', icon: '👁️' },
  { value: 'finished', label: 'Finished', icon: '✓' },
];

/**
 * Sort options
 */
export const SORT_OPTIONS = [
  { value: 'dateAdded', label: 'Recently Added' },
  { value: 'title', label: 'Title (A-Z)' },
  { value: 'author', label: 'Author (A-Z)' },
  { value: 'rating', label: 'Highest Rating' },
  { value: 'progress', label: 'Most Read' },
  { value: 'dateStarted', label: 'Recently Started' },
];

/**
 * Rating options (for filtering)
 */
export const RATING_OPTIONS = [
  { value: 5, label: '★★★★★ 5 stars' },
  { value: 4, label: '★★★★☆ 4+ stars' },
  { value: 3, label: '★★★☆☆ 3+ stars' },
  { value: 2, label: '★★☆☆☆ 2+ stars' },
  { value: 1, label: '★☆☆☆☆ 1+ stars' },
];

/**
 * Emoji options for custom shelves
 */
export const SHELF_EMOJIS = [
  '🐉', '💫', '🔮', '🗡️', '⚔️', '🌙', '☀️', '🌸',
  '💡', '🎭', '🎨', '🎵', '📖', '🔥', '❄️', '🌊',
  '🏰', '🌳', '🎪', '🎢', '🎡', '🌈', '⭐', '💝',
];

/**
 * Animation durations (ms)
 */
export const ANIMATION_DURATIONS = {
  fast: 150,
  standard: 300,
  slow: 500,
};

/**
 * Animation easing functions
 */
export const ANIMATION_EASING = {
  in: 'ease-in',
  out: 'ease-out',
  inOut: 'ease-in-out',
  bounce: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
};

/**
 * Empty state messages
 */
export const EMPTY_STATE_MESSAGES = {
  all: {
    heading: 'Your bookshelf is waiting.',
    subheading: "Let's add great reads to your collection.",
    cta: '+ Add Your First Book',
  },
  tbr: {
    heading: 'Your next story is waiting.',
    subheading: 'Explore and add books to read.',
    cta: 'Browse by Genre',
  },
  reading: {
    heading: 'No books in progress right now.',
    subheading: "Pick one from your TBR to start your next adventure.",
    cta: 'Pick from TBR',
  },
  finished: {
    heading: "No books finished yet!",
    subheading: 'Track your reading journey as you complete books.',
    cta: 'Start Reading',
  },
  favorites: {
    heading: "No favorites yet.",
    subheading: "Add your favorite books to see them here.",
    cta: 'Add Books',
  },
  search: {
    heading: 'No books found.',
    subheading: 'Try a different search term.',
    cta: 'Clear Search',
  },
  filter: {
    heading: "No books match your filters.",
    subheading: 'Try adjusting your selected filters.',
    cta: 'Clear Filters',
  },
  custom: {
    heading: 'This shelf is empty.',
    subheading: 'Add your favorites here!',
    cta: '+ Add Books to This Shelf',
  },
};

/**
 * Breakpoints for responsive design
 */
export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280,
};

/**
 * Grid layout settings
 */
export const GRID_SETTINGS = {
  mobile: {
    columns: 2,
    gap: 12,
  },
  tablet: {
    columns: 3,
    gap: 16,
  },
  desktop: {
    columns: 4,
    gap: 16,
  },
};
